import { Ref, forwardRef } from "react"
import { Form, Formik, FormikProps } from "formik"
import * as yup from "yup"
import { CreateOrEditVatCodesFormValues } from "../vatCodesTypes"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { FormVatCodeContent } from "./FormVatCodeContent"

type CreateOrEditVatCodeFormProps = Readonly<{
    initialValues?: CreateOrEditVatCodesFormValues | null
    onSubmit: (formData: CreateOrEditVatCodesFormValues) => void
}>

const defaultInitialValues: CreateOrEditVatCodesFormValues = {
    name: "",
    code: "",
    vatPercentage: {
        amount: "",
        scale: 1,
    },
}

type FormikRef = Ref<FormikProps<CreateOrEditVatCodesFormValues>>

export const CreateUpdateVatCodeForm = forwardRef(
    ({ initialValues, onSubmit }: CreateOrEditVatCodeFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const validationSchema = yup.object({
            code: yup.string().required(l10n.getString("merchant-vat-codes-create-edit-required-code")),
            name: yup.string().required(l10n.getString("merchant-vat-codes-create-edit-required-name")),
            vatPercentage: yup.object({
                amount: yup
                    .number()
                    .required(l10n.getString("merchant-vat-codes-create-edit-required-vat-percentage-amount"))
                    .typeError(l10n.getString("merchant-vat-codes-create-edit-type-error-vat-percentage-amount")),
            }),
        })

        function handleSubmit(values: CreateOrEditVatCodesFormValues) {
            onSubmit(values)
        }

        return (
            <Formik<CreateOrEditVatCodesFormValues>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <FormVatCodeContent />
                </Form>
            </Formik>
        )
    },
)
